import { inject } from '@angular/core';
import { environment } from '@env';
import { AuthenticationType } from '../models/authentication-type.enum';
import { AUTH_SERVICE_TOKEN, IAuthService } from '../models/iauth-service.model';
import { AzureADAuthService } from '../services/aad-auth.service';
import { AzureB2CAuthService } from '../services/b2c-auth.service';
import { BasicAuthService } from '../services/basic-auth.service';

const authServiceFactory = (): IAuthService => {
  switch (environment.authenticationType) {
    case AuthenticationType.Anonymous:
    case AuthenticationType.ActiveDirectory:
      return inject(BasicAuthService);
    case AuthenticationType.AzureActiveDirectory:
      return inject(AzureADAuthService);
    case AuthenticationType.AzureB2C:
      return inject(AzureB2CAuthService);
  }
};

export const authServiceProvider = {
  provide: AUTH_SERVICE_TOKEN,
  useFactory: authServiceFactory,
};
